import { Dialog, DialogContent, Stack } from '@mui/material';
import { paymentFormActions } from '@common-reducers/PaymentFormReducer';
import { closePaymentDialogThunk } from '@common-reducers/PaymentFormThunks';
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import ThankYouView from '@common-views/thank-you-view/thank-you-view';
import { namespace } from '@common/config/constants';
import { useTranslation } from 'react-i18next';

export default function PaymentThankYouPopup() {
    const { t } = useTranslation(namespace);
    const dispatch = useAppDispatch();
    const purchaseSuccess = useAppSelector((state) => state.PaymentFormReducer.paymentSuccess);
    const closeDialog = () => {
        dispatch(closePaymentDialogThunk())
        dispatch(paymentFormActions.setPaymentSuccess(false))
    }

    return (
        <Dialog fullScreen sx={{
            p: 3
        }} open={!!purchaseSuccess} onClose={closeDialog}>
            <DialogContent sx={{ background: 'linear-gradient(180deg, var(--color-surface) 0%, #E8F9FD 100%)', display: 'flex' }}>
                <Stack sx={{ width: 1 }} justifyContent={"center"}>
                    <ThankYouView />
                </Stack>
            </DialogContent>
        </Dialog>
    )
}

